module.exports = __webpack_public_path__ + "static/img/txtbtn_arrow_on.068ef48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/txtbtn_arrow_on.png
// module id = nINo
// module chunks = 10